import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initial = {
    allFarmingTypes: [],
    allSoilTypes: [],
    campaigns: [],
    campaignFrom: undefined,
    campaignTo: undefined,
    selectedCampaigns: [],
    farmingType: undefined,
    soilType: undefined,
    crops: [],
    clay: undefined,
    organicMaterial: undefined,
    density: undefined,
    calculationResult: [],
};

export default createReducer(initial, {
    [actions.setAllFarmingTypes]: (state, action) => {
        return { ...state, allFarmingTypes: action.payload };
    },
    [actions.setAllSoilTypes]: (state, action) => {
        return { ...state, allSoilTypes: action.payload };
    },
    [actions.setCampaigns]: (state, action) => {
        return { ...state, campaigns: action.payload };
    },
    [actions.setCampaignFrom]: (state, action) => {
        return { ...state, campaignFrom: action.payload };
    },
    [actions.setCampaignTo]: (state, action) => {
        return { ...state, campaignTo: action.payload };
    },
    [actions.setSelectedCampaigns]: (state, action) => {
        return { ...state, selectedCampaigns: action.payload };
    },
    [actions.setSelectedCampaign]: (state, { payload: { season, newCampaign } }) => {
        const selectedCampaigns = { ...state.selectedCampaigns };
        selectedCampaigns[season] = { ...selectedCampaigns[season], ...newCampaign };

        return { ...state, selectedCampaigns };
    },
    [actions.setFarmingType]: (state, action) => {
        return { ...state, farmingType: action.payload };
    },
    [actions.setSoiltype]: (state, action) => {
        return { ...state, soilType: action.payload };
    },
    [actions.setAllCrops]: (state, action) => {
        return { ...state, crops: action.payload };
    },
    [actions.setClay]: (state, action) => {
        return { ...state, clay: action.payload };
    },
    [actions.setOrganicMaterial]: (state, action) => {
        return { ...state, organicMaterial: action.payload };
    },
    [actions.setDensity]: (state, action) => {
        return { ...state, density: action.payload };
    },
    [actions.setCalculationResult]: (state, action) => {
        return { ...state, calculationResult: action.payload };
    },
});
